module.exports = __webpack_public_path__ + "static/media/hw_nu_23.2657add1.flv";